module.exports = __webpack_public_path__ + "officialStatic/img/soft12.ad8d822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft12.png
// module id = eUkM
// module chunks = 0